export default "<!-- Place all UI elements intended to be present across all routes in this file -->\n<div ui-view=\"app\"></div>\n";